import { useState } from 'react';

function Resources() {
  const [activeTab, setActiveTab] = useState('articles');
  
  // ========== المقالات ==========
  const articles = [
    {
      title: '📝 الصحة النفسية للمراهقات',
      content: 'نصائح وإرشادات للتعامل مع الضغوط النفسية خلال فترة المراهقة. تعلمي كيف تعتني بصحتك النفسية وتحمي نفسك من التوتر والقلق.',
      link: 'https://www.who.int/ar/news-room/fact-sheets/detail/adolescent-mental-health'
    },
    {
      title: '😌 كيف تتغلبين على القلق',
      content: 'طرق بسيطة وفعالة للتخلص من التوتر والقلق اليومي. تمارين تنفس ونصائح عملية لتخفيف التوتر.',
      link: 'https://www.mayoclinic.org/ar/diseases-conditions/anxiety/symptoms-causes/syc-20350961'
    },
    {
      title: '😴 أهمية النوم للصحة النفسية',
      content: 'تعرفي على علاقة النوم الجيد بالمزاج والصحة النفسية. نصائح لتحسين جودة نومك والحصول على راحة أفضل.',
      link: 'https://www.sleepfoundation.org/mental-health'
    },
    {
      title: '💪 كيفية بناء الثقة بالنفس',
      content: 'خطوات عملية لتعزيز ثقتك بنفسك وتقدير ذاتك. ابدأي رحلتك نحو شخصية أقوى وأكثر ثقة.',
      link: 'https://www.psychologytoday.com/us/basics/self-esteem'
    }
  ];
  
  // ========== تمارين تنفس ==========
  const breathingExercises = [
    {
      title: '🌬️ تمرين التنفس 4-7-8',
      description: 'استنشقي لمدة 4 ثواني، احبسي النفس 7 ثواني، أخرجي النفس ببطء لمدة 8 ثواني',
      icon: '🌬️',
      steps: ['استنشقي 4 ثواني', 'احبسي 7 ثواني', 'ازفري 8 ثواني'],
      duration: '2 دقائق'
    },
    {
      title: '🧘 تمرين التنفس البطني',
      description: 'ضعي يدك على بطنك وتنفسي بعمق، اشعري ببطنك يرتفع وينخفض',
      icon: '🧘',
      steps: ['اجلسي بوضع مريح', 'ضعي يدك على بطنك', 'تنفسي بعمق 10 مرات'],
      duration: '3 دقائق'
    },
    {
      title: '💨 تمرين الزفير الطويل',
      description: 'شهيق سريع لمدة ثانيتين، ثم زفير بطيء لمدة 6 ثواني - يساعد على تهدئة القلق',
      icon: '💨',
      steps: ['شهيق سريع (ثانيتين)', 'زفير بطيء (6 ثواني)', 'كرري 8 مرات'],
      duration: '2 دقائق'
    },
    {
      title: '🌸 تمرين التنفس المربع',
      description: 'استنشاق 4 ثواني - حبس 4 ثواني - زفير 4 ثواني - توقف 4 ثواني، ثم كرري',
      icon: '🌸',
      steps: ['استنشاق 4 ثواني', 'حبس النفس 4 ثواني', 'زفير 4 ثواني', 'توقف 4 ثواني'],
      duration: '3 دقائق'
    }
  ];
  
  // ========== نصائح سريعة ==========
  const quickTips = [
    '🌟 خذي 5 دقائق يومياً للتنفس العميق',
    '📝 دوّني مشاعرك يومياً في مفكرة',
    '💧 اشربي كوب ماء عند الشعور بالتوتر',
    '🚶 امشي 10 دقائق يومياً في الهواء الطلق',
    '😊 ابتسمي حتى لو كنتِ حزينة - الابتسامة تخدع الدماغ فيشعر بالسعادة'
  ];
  
  // ========== فيديو واحد شغال ==========
  const relaxingVideo = {
    title: '🌿 تأمل وموسيقى هادئة للاسترخاء',
    description: 'جلسة تأمل قصيرة مع موسيقى هادئة لتهدئة الأعصاب والاسترخاء',
    url: 'https://www.youtube-nocookie.com/embed/inpok4MKVLM',
    duration: '10 دقائق'
  };
  
  // ========== أرقام الدعم النفسي ==========
  const supportLines = [
    { country: '🇪🇬 مصر', number: '16328', organization: 'خط الدعم النفسي - وزارة الصحة', hours: '24 ساعة' },
    { country: '🇸🇦 السعودية', number: '920033360', organization: 'مركز الصحة النفسية - وزارة الصحة', hours: '24 ساعة' },
    { country: '🇦🇪 الإمارات', number: '800 4673', organization: 'خط المساعدة النفسية', hours: '24 ساعة' },
    { country: '🇯🇴 الأردن', number: '110', organization: 'الخط الوطني للمساعدة', hours: '24 ساعة' },
    { country: '🇵🇸 فلسطين', number: '121', organization: 'دعم نفسي', hours: '24 ساعة' },
    { country: '🌍 عربي', number: '+962 6 562 4747', organization: 'خط المساعدة النفسية العربي', hours: '24 ساعة' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-100 to-purple-200 pt-20 p-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold text-center text-purple-800 mb-4">📚 الموارد والدعم النفسي</h1>
        <p className="text-center text-gray-700 mb-8 text-lg">كل ما تحتاجينه لدعم صحتك النفسية في مكان واحد</p>
        
        {/* ========== التبويبات ========== */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          <button 
            onClick={() => setActiveTab('articles')} 
            className={`px-6 py-3 rounded-xl font-bold transition duration-200 ${
              activeTab === 'articles' 
                ? 'bg-purple-600 text-white shadow-lg' 
                : 'bg-white text-gray-600 hover:bg-purple-100'
            }`}
          >
            📝 مقالات
          </button>
          <button 
            onClick={() => setActiveTab('video')} 
            className={`px-6 py-3 rounded-xl font-bold transition duration-200 ${
              activeTab === 'video' 
                ? 'bg-purple-600 text-white shadow-lg' 
                : 'bg-white text-gray-600 hover:bg-purple-100'
            }`}
          >
            🎬 فيديو استرخاء
          </button>
          <button 
            onClick={() => setActiveTab('breathing')} 
            className={`px-6 py-3 rounded-xl font-bold transition duration-200 ${
              activeTab === 'breathing' 
                ? 'bg-purple-600 text-white shadow-lg' 
                : 'bg-white text-gray-600 hover:bg-purple-100'
            }`}
          >
            🌬️ تمارين التنفس
          </button>
          <button 
            onClick={() => setActiveTab('tips')} 
            className={`px-6 py-3 rounded-xl font-bold transition duration-200 ${
              activeTab === 'tips' 
                ? 'bg-purple-600 text-white shadow-lg' 
                : 'bg-white text-gray-600 hover:bg-purple-100'
            }`}
          >
            💡 نصائح سريعة
          </button>
          <button 
            onClick={() => setActiveTab('support')} 
            className={`px-6 py-3 rounded-xl font-bold transition duration-200 ${
              activeTab === 'support' 
                ? 'bg-purple-600 text-white shadow-lg' 
                : 'bg-white text-gray-600 hover:bg-purple-100'
            }`}
          >
            📞 دعم نفسي
          </button>
        </div>
        
        {/* ========== قسم المقالات ========== */}
        {activeTab === 'articles' && (
          <div className="grid gap-6">
            {articles.map((article, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition duration-300">
                <h3 className="text-xl font-bold text-purple-700 mb-2">{article.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{article.content}</p>
                <a 
                  href={article.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-800 font-semibold transition"
                >
                  اقرأ المزيد ←
                </a>
              </div>
            ))}
          </div>
        )}
        
        {/* ========== قسم الفيديو الوحيد ========== */}
        {activeTab === 'video' && (
          <div className="bg-white rounded-2xl p-6 shadow-lg">
            <div className="flex items-center gap-3 mb-4">
              <div className="text-4xl">🌿</div>
              <div>
                <h3 className="text-2xl font-bold text-purple-700">{relaxingVideo.title}</h3>
                <p className="text-gray-600">{relaxingVideo.description}</p>
                <p className="text-sm text-gray-500 mt-1">⏱️ المدة: {relaxingVideo.duration}</p>
              </div>
            </div>
            <div className="relative pb-[56.25%] h-0 rounded-lg overflow-hidden">
              <iframe
                src={relaxingVideo.url}
                title={relaxingVideo.title}
                className="absolute top-0 left-0 w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="text-center text-gray-500 text-sm mt-4">
              🎧 استخدمي سماعات الأذن للحصول على تجربة أفضل
            </p>
          </div>
        )}
        
        {/* ========== قسم تمارين التنفس ========== */}
        {activeTab === 'breathing' && (
          <div className="grid gap-6">
            {breathingExercises.map((exercise, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="text-5xl">{exercise.icon}</div>
                  <div>
                    <h3 className="text-2xl font-bold text-purple-700">{exercise.title}</h3>
                    <p className="text-gray-500 text-sm">⏱️ {exercise.duration}</p>
                  </div>
                </div>
                <p className="text-gray-700 mb-4">{exercise.description}</p>
                <div className="bg-purple-50 rounded-xl p-4">
                  <p className="font-semibold text-purple-800 mb-2">📋 الخطوات:</p>
                  <ul className="space-y-2">
                    {exercise.steps.map((step, i) => (
                      <li key={i} className="flex items-center gap-2 text-gray-700">
                        <span className="text-purple-500">•</span>
                        {step}
                      </li>
                    ))}
                  </ul>
                </div>
                <button 
                  onClick={() => {
                    alert(`🧘 ابدئي تمرين ${exercise.title}\n\nاتبعي الخطوات: ${exercise.steps.join(' → ')}\n\n${exercise.duration}`);
                  }}
                  className="mt-4 w-full bg-purple-600 text-white py-3 rounded-xl hover:bg-purple-700 transition font-semibold"
                >
                  ابدئي التمرين 🧘
                </button>
              </div>
            ))}
          </div>
        )}
        
        {/* ========== قسم النصائح السريعة ========== */}
        {activeTab === 'tips' && (
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-bold text-purple-700 mb-6 text-center">✨ نصائح سريعة لصحتك النفسية</h2>
            <div className="grid gap-4">
              {quickTips.map((tip, index) => (
                <div key={index} className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-4 flex items-center gap-3">
                  <span className="text-2xl">💜</span>
                  <p className="text-gray-800">{tip}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 text-center text-gray-500 text-sm">
              <p>🌟 جربي تطبيق نصيحة واحدة يومياً وستلاحظين الفرق</p>
            </div>
          </div>
        )}
        
        {/* ========== قسم الدعم النفسي ========== */}
        {activeTab === 'support' && (
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="bg-gradient-to-r from-red-50 to-pink-50 border border-red-200 rounded-xl p-6 mb-8 text-center">
              <div className="text-6xl mb-4">🆘</div>
              <h3 className="text-2xl font-bold text-red-700 mb-2">إذا كنتِ بحاجة للمساعدة فوراً</h3>
              <p className="text-gray-700">هذه الأرقام مجانية ومتاحة 24 ساعة طوال أيام الأسبوع</p>
              <p className="text-sm text-gray-500 mt-2">لا تترددي في الاتصال - المساعدة متاحة دائماً</p>
            </div>
            
            <div className="grid gap-4">
              {supportLines.map((line, index) => (
                <div key={index} className="border border-gray-200 rounded-xl p-4 hover:bg-purple-50 transition duration-200">
                  <div className="flex justify-between items-center flex-wrap gap-4">
                    <div>
                      <h4 className="font-bold text-gray-800 text-lg">{line.country}</h4>
                      <p className="text-sm text-gray-600">{line.organization}</p>
                      <p className="text-xs text-gray-400 mt-1">🕐 {line.hours}</p>
                    </div>
                    <div className="text-left">
                      <p className="text-2xl font-bold text-purple-700" dir="ltr">{line.number}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <p className="text-sm text-gray-500 mt-6 text-center">
              * جميع الأرقام مجانية ومتاحة 24/7
            </p>
          </div>
        )}
        
        {/* ========== نصيحة اليوم ========== */}
        <div className="mt-8 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-4 text-center">
          <p className="text-purple-800 text-lg">
            💜 تذكري: صحتك النفسية مهمة، ونحن هنا لدعمك في كل خطوة
          </p>
        </div>
      </div>
    </div>
  );
}

export default Resources;